import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/workspace/$workspaceSlug/knowledge/")({
  loader: ({ params }) => {
    throw redirect({
      to: "/workspace/$workspaceSlug/knowledge/company-profiles",
      params: { workspaceSlug: params.workspaceSlug },
    });
  },
});
